import React from 'react';

const AboutPage = () => {
  return (

    <div
      className="relative min-h-screen text-white font-sans"
      dir="rtl"
      style={{ direction: 'rtl', textAlign: 'right' }}
    >

      {                     }
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <img
          src="/images/stars.png"
          alt="Background Stars"
          className="w-full h-full object-cover opacity-80"
        />
      </div>

      {             }
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">

        {            }
        <header className="mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#28e3da40] bg-[#081423]/30 px-4 py-1 mb-4">
            {                                               }
            <span className="inline-block w-2 h-2 rounded-full bg-[#28E3DA]" />
            <span className="text-xs sm:text-sm text-[#E4F1FF]">منصة طلابية مستقلة</span>
          </div>

          <h1 className="text-3xl md:text-4xl font-semibold text-[#F5F6FF] mb-4">
            حول همّة
          </h1>

          <p className="text-sm sm:text-base md:text-lg leading-loose text-[#CBD5F5] max-w-3xl">
            همّة منصة طلابية مستقلة موجّهة لطلبة جامعة جدة، بدأت عام 2020 بهدف توفير أدوات
            وخدمات تسهّل على الطالب اتخاذ قرارات أوضح خلال رحلته الدراسية. المنصة ليست جهة
            رسمية، لكنها أداة مساعدة تعتمد بشكل كبير على تجارب الطلاب الفعلية.
          </p>
        </header>

        {             }
        <section className="mb-12 md:mb-16">
          <h2 className="text-2xl font-semibold text-[#F5F6FF] mb-3">
            ماذا تقدم المنصة ؟
          </h2>

          <p className="text-[#CBD5F5] text-sm sm:text-base mb-8 leading-loose">
            خدمات عملية تساعد الطالب في الفهم واتخاذ قرارات واقعية بدون وعود مبالغ فيها.
          </p>

          {          }
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {           }
            <div className="relative rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <div className="absolute -top-3 left-4 bg-[#081423] border border-[#28e3da40] rounded-full px-3 py-1 text-xs text-[#E4F1FF]">
                تجارب وآراء
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-[#F5F6FF] mb-2">
                تقييم المقررات وأعضاء هيئة التدريس
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                مساحة يشارك فيها الطلاب تجاربهم حول المقررات والدكاترة بهدف إعطاء صورة واقعية
                تساعد الطالب قبل التسجيل. التقييمات تعكس آراء أصحابها ولا تُعد مرجعًا رسميًا.
              </p>
            </div>

            {           }
            <div className="relative rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <div className="absolute -top-3 left-4 bg-[#081423] border border-[#28e3da40] rounded-full px-3 py-1 text-xs text-[#E4F1FF]">
                أدوات حسابية
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-[#F5F6FF] mb-2">
                حاسبة أكاديمية
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                أدوات بسيطة لحساب المعدل ونسبة الغياب وتأثير الدرجات. النتائج تقديرية
                وتعتمد على صحة البيانات المدخلة، ولا تغني عن السجلات الرسمية.
              </p>
            </div>

            {           }
            <div className="relative rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <div className="absolute -top-3 left-4 bg-[#081423] border border-[#28e3da40] rounded-full px-3 py-1 text-xs text-[#E4F1FF]">
                مجتمع ونقاشات
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-[#F5F6FF] mb-2">
                مجتمع طلابي
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                مساحة لتبادل الخبرات بين الطلاب حول المواد والخطط الدراسية ونصائح الحياة الجامعية.
                المحتوى يعكس تجارب الطلاب وليس مرجعًا أكاديميًا.
              </p>
            </div>

            {           }
            <div className="relative rounded-2xl border border-[#28e3da40] bg-[#081423]/40 p-6">
              <div className="absolute -top-3 left-4 bg-[#081423] border border-[#28e3da40] rounded-full px-3 py-1 text-xs text-[#E4F1FF]">
                أدوات مساندة
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-[#F5F6FF] mb-2">
                أدوات وخدمات إلكترونية
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5F5] leading-loose">
                مجموعة من الأدوات التي تساعد الطالب على تنظيم جدوله وفهم مساره الدراسي، إضافة
                لمصادر قد تكون مفيدة. هذه الأدوات دورها مساند فقط.
              </p>
            </div>

          </div>
        </section>

        {            }
        <section className="border border-[#28e3da40] bg-[#081423]/50 rounded-2xl p-5">
          <h4 className="text-lg font-semibold text-[#5FCC9C] mb-2">
            ملاحظة مهمّة
          </h4>
          <p className="text-sm sm:text-base text-[#E4F1FF] leading-loose">
            همّة لا تمثّل جهة رسمية. هدف المنصة هو تقديم أدوات ومحتوى مبسط يعتمد على مشاركة
            الطلاب أنفسهم. القيمة الحقيقية تأتي من وعي الطالب وكيفية استخدامه للمعلومات.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;